var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 10.6821C22.1668 12.3403 10.5 25.0572 10.5 40.499C10.5 57.0676 23.9315 70.499 40.5 70.499C55.9419 70.499 68.6588 58.8322 70.3169 43.8324H37.1667V10.6821Z",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7927 30.499H50.5V12.2067C59.0239 15.2195 65.7798 21.9752 68.7927 30.499Z",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAdmin);
export default __webpack_public_path__ + "static/media/Btn_Admin.d36ea91ad35ce930cbc434b18d853187.svg";
export { ForwardRef as ReactComponent };